import { Box, StatusLabel } from '@factorialco/deprecated-design-system'
import { FinanceValueObjectsInvoiceStatusEnum } from 'generated/resources/graphql'

import { invoiceStatusTagType, mapStatusText } from 'modules/finance/lib/invoices'

interface StatusProps {
  status: FinanceValueObjectsInvoiceStatusEnum
}

export const Status = ({ status }: StatusProps) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <StatusLabel type={invoiceStatusTagType(status)}>{mapStatusText(status)}</StatusLabel>
    </Box>
  )
}
